import { Button, Container, Overlay, Text, Title } from '@mantine/core';
import classes from './Hero.module.css';
import React from "react";
import { useNavigate } from "react-router-dom";
import { useSelector } from 'react-redux';

const Hero = (props) => {
    const isAuthenticated = useSelector( (state) => state.auth.isAuthenticated )
    const role = useSelector( (state) => state.auth.role );
    const redirectUri = isAuthenticated ? `/${role?.toLowerCase()}` : "/get-started";
    const navigate = useNavigate();

    const navigateSignup = () => {
        navigate(redirectUri);
    };

    return (
        <div className={classes.hero}>
            <Overlay
                gradient="linear-gradient(180deg, rgba(0, 0, 0, 0.25) 0%, rgba(0, 0, 0, .65) 40%)"
                opacity={1}
                zIndex={0}
            />
            <Container className={classes.heroContainer} size="md">
                <Title className={classes.heroTitle}>
                    Relax,<br/>It's laundry day.
                </Title>
                <Text className={classes.heroDescription} size="xl" mt="xl">
                    Your laundry picked up, washed, folded, and delivered in 24 hours - every week. Designed for apartment communities.
                </Text>
                <Button
                    size="xl"
                    radius="xl"
                    className={classes.heroControl}
                    onClick={navigateSignup}
                >
                    Get Started!
                </Button>
            </Container>
        </div>
    );
};

export default Hero;